import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const liver = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
